<template>
    <div>
        <h1 style="font-size: 24px; color: black;">默认配置</h1>
        <div style="margin-bottom: 10px;">
            <el-button type="primary" @click="showDetails('新增配置')">添加配置</el-button>
        </div>
        <h1>
            <el-table border max-height="550"
                      :data="blocks">
                <el-table-column  label="编号" prop="id"  align="center"></el-table-column>
                <el-table-column  label="名称" prop="name"  align="center"></el-table-column>
                <el-table-column  label="位置"   align="center">
                    <template slot-scope="scope">
                        <el-row v-if="scope.row.type===3 " >{{'灵动岛'}}</el-row>
                        <el-row v-if="scope.row.type===4 " >{{'用户默认'}}</el-row>
                    </template>
                </el-table-column>
                <el-table-column  label="操作"  align="center">
                    <template slot-scope="scope">
                        <el-button  plain size="mini" type="primary" @click="showDetails('编辑配置',scope.row)">编辑</el-button>
                        <el-button plain size="mini" type="danger" @click="remove(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
                <el-table-column  label="选品"  align="center">
                    <template slot-scope="scope">
                        <el-button  plain size="mini" type="success" @click="appLinkSelect(scope.row)">去关联</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
                <el-form :model="blockEditForm" :label-width="labelWidth">
                    <el-form-item label="名称:" >
                        <el-input  style="width: 300px" type="text" v-model="blockEditForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="位置 :" :label-width="labelWidth">
                        <el-select v-model="blockEditForm.type" placeholder="请选择">
                            <el-option v-for="type in types"
                                       :key="type.id"
                                       :label="type.name"
                                       :value="type.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmForm">确 定</el-button>
                        <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </h1>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
        </el-pagination>
    </div>
</template>

<script>
    import {
        searchBlock,
        saveBlock,
        deleteBlock
    } from "@/http/iosApi";
    export default {
        name: "DefaultManage",
        data(){
            return{
                block:{},
                blocks:[],
                labelWidth: '150px',
                dialogVisible: false,
                dialogTitle :'',
                blockEditForm: {},
                queryData: {},
                types:[{"id":3,"name":"灵动岛"},{"id":4,"name":"用户默认"}],
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                }
            }
        },
        methods:{
            goBack() {
                this.$router.push({path: '/categoryManage'});
            },
            search() {
                this.queryData.size = this.page.size;
                this.queryData.page = this.page.page;
                this.queryData.type = [3,4];
                this.queryData.parentId = null;
                searchBlock(this.queryData).then(resp => {
                    this.blocks = resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements
                })
            },

            handleSizeChange(size) {
                this.page.size = size;
                this.search();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.search();
            },

            showDetails(title, row) {
                this.blockEditForm = {
                    "id" : 0,
                    "name" :'',
                    "type": 3,
                    "state": true

                };

                this.dialogTitle = title;
                this.dialogVisible = true;

                if(row){
                    this.blockEditForm = {
                        "id" : row.id,
                        "name" :row.name,
                        "type": row.type,
                        "state":  row.state
                    };
                }
            },
            confirmForm(){
                let _message = '';
                if(this.blockEditForm.name===''){
                    _message = '请输入应用名称'
                }else if (this.blockEditForm.type===''){
                    _message = '请选择位置'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveBlock(this.blockEditForm).then(resp => {
                    if (resp.data.status === 0 ){
                        this.search();
                        this.dialogVisible = false;
                    }
                });
            },
            remove(id){
                this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteBlock(id).then(resp=> {
                        if (resp.data.status === 0) {
                            this.search()
                        }
                    });
                }).catch(() => {
                })
            },
            appLinkSelect(secondBlock){
                this.$store.commit('addSecondBlock', secondBlock);
                this.$router.push({ path: '/selectAppLink'});
            }
        },
        created() {
            this.search();
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>